import NewStudy from './ui/newStudy/newStudy';

export default NewStudy;
